export default {
  findYourBill: {
    titlePage: 'Find Your Bill',
    description: 'Pay your home insurance invoice quickly and securely.',
    note: '',
    policyNumber: 'Policy Number',
    help: 'Where can I find this?',
    zipCode: 'Property Zip Code',
    mismatch: 'The Policy Number or Zip Code you entered was incorrect.'
  },
  paymentInformation: {
    titlePage: 'Payment Information',
    policyInformation: 'Policy Information',
    policyNumber: 'Policy Number',
    address: 'Insured Address',
    agency: 'Agency',
    amount: 'Amount',
    noCurrentBalance: {
      noAmountDue: 'There is no amount due at this time.',
      remainingBalancePart1: 'You have a remaining balance of ',
      remainingBalancePart2: ' due on your current policy term.'
    },
    noRemainingBalance: 'The current policy term is paid in full. <br>You may still make payments on a renewal policy term.',
    paymentOptions: {
      title: 'How much would you like to pay?',
      paymentMethod: 'Choose a payment method.'
    },
    cardInformation: {
      title: 'Payment by Credit Card',
      cardsAccepted: 'Cards accepted:',
      nameOnCard: 'Name on Card',
      cardNumber: 'Card Number',
      expiration: 'Expiration',
      cvv: 'CVV'
    },
    eCheck: {
      title: 'Payment by eCheck',
      accountType: 'Account Type',
      bankAccountHolderName: 'Bank Account Holder Name',
      bankName: 'Bank Name',
      bankRoutingNumber: 'Bank Routing Number',
      bankAccountNumber: 'Bank Account Number'
    },
    billingInformation: {
      title: 'Billing Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      aptSuite: 'Apt./Suite',
      streetAddress: 'Street Address',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code'
    },
    cancelButton: 'Cancel',
    reviewButton: 'Review Payment'
  },
  review: {
    titlePage: 'Review Payment',
    dueOn: 'Scheduled to pay on',
    policyNumber: 'Policy Number',
    address: 'Insured Address',
    paymentAmount: 'Payment Amount',
    paymentDate: 'Payment Date',
    billingInformation: 'Billing Information',
    cardInformation: {
      nameOnCard: 'Name on Card',
      cardInformation: 'Card Information',
      expiration: 'Expiration'
    },
    eCheck: {
      bankAccountHolderName: 'Bank Account Holder Name',
      bankName: 'Bank Name',
      bankRoutingNumber: 'Bank Routing Number',
      bankAccountNumber: 'Bank Account Number'
    },
    cancelButton: 'Cancel',
    confirmButton: 'Confirm Payment',
    backButton: 'Back',
    sendPayment: 'Sending your payment information...',
    sendPaymentMessage: 'Do not click the back button, refresh your browser, or try to submit the payment again as this could cause you to be billed multiple times.'
  },
  confirmation: {
    paymentSuccessful: 'Payment successful.',
    amount: 'Your payment in the amount of',
    submitted: 'has been submitted for policy',
    transactionNumber: 'Your transaction number is',
    delay: 'It may take up to 24 hours for your payment to show up in your bank account.',
    sfiCobrand: {
      title: 'Manage your home insurance with ease using the My Security First portal.',
      details: {
        detail1: 'View payment schedule',
        detail2: 'Review policy documents',
        detail3: 'Report a claim and view claim statuses'
      },
      signUpText: 'Sign Up Today',
      signUpUrl: 'https://my.securityfirstflorida.com/'
    }
  },
  loadingProcessingPayment: {
    title: 'Sending your payment information...',
    description: 'Do not click the Back button, refresh your browser, or try to submit the payment again as this could result in multiple payments.'
  },
  errorPage: {
    generalError: {
      title: 'Error',
      description: 'The system timed out or there was an error.',
      details: 'You can go back and retry. You can also contact your agent or call 1-877-333-9992.',
      buttonText: 'Retry'
    },
    unknownFailure: {
      title: 'Payment Error',
      description: 'Your payment was not submitted due to an error.',
      details: 'Please contact your agent or call 1-877-333-9992. Do not click the Back button, refresh your browser, or try to submit the payment again as this could result in multiple payments. We apologize for the inconvenience.'
    },
    knownPaymentError: {
      title: 'Payment Error',
      description: 'Your payment was not submitted due to an error.',
      details: 'You can go back and retry the payment. You can also contact your agent or call 1-877-333-9992.',
      buttonText: 'Retry Payment'
    },
    tcErrorDecline: {
      title: 'Payment Error',
      description: 'Your credit card or e-check was declined.',
      details: 'Please verify the information you\'ve entered or try again with a different payment method. If the issue persists, please call your bank or credit card provider for assistance.',
      buttonText: 'Edit Payment Info'
    },
    tcErrorDuplicate: {
      title: 'Payment Error',
      description: 'This appears to be a duplicate payment.',
      details: 'Please allow 24 hours from your last payment to attempt another.',
      buttonText: 'Edit Payment Info'
    },
    tcErrorCvv: {
      title: 'Payment Error',
      description: 'The submitted CVV is incorrect.',
      details: 'Please verify the information you\'ve entered or try again with a different payment method. If the issue persists, please call your bank or credit card provider for assistance.',
      buttonText: 'Edit Payment Info'
    },
    tcErrorCall: {
      title: 'Payment Error',
      description: 'Authorization is required for this payment.',
      details: 'Please call the service number for your bank or credit card provider.',
      buttonText: 'Edit Payment Info'
    },
    tcErrorCarderror: {
      title: 'Payment Error',
      description: 'The card number is invalid.',
      details: 'Please verify the information you\'ve entered or try again with a different payment method. If the issue persists, please call your bank or credit card provider for assistance.',
      buttonText: 'Edit Payment Info'
    }
  },
  redirect: {
    specialtyLinesPolicy: {
      title: 'Oops, you\'ve entered a Specialty Lines policy number.',
      message: 'This site does not process payments for Specialty Lines policies. To make a payment, please contact your agent or call 1-877-326-8080.',
      button: 'Back'
    },
    floridaPolicy: {
      title: 'Oops, you\'ve entered a Florida policy number.',
      message: 'This site does not process payments for Florida policies. Luckily, we have plenty of options for you that you can learn about on our Florida website.',
      button: 'Payment Center'
    },
    missouriPolicy: {
      title: 'Oops,  that\'s not a Florida policy number.',
      message: 'The Policy you entered is for a different state. No worries, we have options for you!',
      note: 'to make a payment on your non-Florida policy',
      button: 'Click here'
    }
  },
  maintenance: {
    header: 'Payments have been temporarily disabled.',
    details: 'We\'re currently performing maintenance on the payments system. We apologize for the inconvenience.'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/strings.js